const ProductsList = [
  {
    targetLink: "/mp",
    label: "Caseworker.mp"
  },
  {
    targetLink: "/scot",
    label: "Caseworker.scot"
  },
  {
    targetLink: "/mla",
    label: "Caseworker.mla"
  },
  {
    targetLink: "/td",
    label: "Caseworker.td"
  },
  {
    targetLink: "/gov",
    label: "Caseworker.gov"
  },
  {
    targetLink: "/voter",
    label: "Voter.ID"
  }
];

export default ProductsList;



// WEBPACK FOOTER //
// ./src/content/productsList.js